import { palettes, type ThemeMode } from './tokens';

/**
 * Projects the active palette onto CSS custom properties (`--ol-*`) on <html>, so the canvas
 * layer (lanes/nodes/edges styled in global.css) tracks the AntD theme without prop-drilling.
 * tokens.ts stays canonical; this avoids duplicating hex values in CSS.
 */
export function applyThemeVars(mode: ThemeMode): void {
  const p = palettes[mode];
  const root = document.documentElement;
  root.dataset.theme = mode;
  root.style.colorScheme = mode;
  const set = (k: string, v: string) => root.style.setProperty(k, v);

  set('--ol-bg-base', p.bgBase);
  set('--ol-bg-container', p.bgContainer);
  set('--ol-bg-elevated', p.bgElevated);
  set('--ol-bg-subtle', p.bgSubtle);
  set('--ol-border', p.border);
  set('--ol-border-strong', p.borderStrong);
  set('--ol-border-subtle', p.borderSubtle);
  set('--ol-text-primary', p.textPrimary);
  set('--ol-text-secondary', p.textSecondary);
  set('--ol-text-tertiary', p.textTertiary);
  set('--ol-text-inverse', p.textInverse);
  set('--ol-primary', p.primary);
  set('--ol-focus-ring', p.focusRing);
  set('--ol-positive', p.positive);
  set('--ol-attention', p.attention);
  set('--ol-negative', p.negative);
  set('--ol-info', p.info);
  set('--ol-processing', p.processing);
}
